export const scoreHelper = (event) => {
    let homeScore = event.score.homeScore;
    let awayScore = event.score.awayScore;
    if (event.isTeamSwap) {
        homeScore = event.score.awayScore;
        awayScore = event.score.homeScore;
    }
    return { homeScore, awayScore };
};
//# sourceMappingURL=scoreHelper.js.map